export const defaultComponentProps = {
  title: 'Confirm action'
}
export const defaultModalProps = (customClass = '') => ({
  adaptive:true,
  reset:true,
  classes: `custom-modal modal-dialog modal-type-1 ${customClass}`,
  shiftX: 0,
  shiftY: 0
})

export const defaultModalEvents = (beforeCloseCb) => ({
  'before-close'({params}) {
    if (params?.applied) return
    beforeCloseCb && beforeCloseCb()
  },
})